var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulpSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.28 44 29 28.27a1.85 1.85 0 0 0-3.32-1 1.85 1.85 0 0 0 1.48 3h9.74a1.85 1.85 0 0 0 1.48-3 1.85 1.85 0 0 0-3.32 1L33.72 44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.41 44c0-5.41 4.35-10.27 6.6-13.66a14.34 14.34 0 0 0 2.38-8.81C46 14.35 41 8 32 8s-14.41 6.08-14.41 14.38a14.33 14.33 0 0 0 2.48 8.09c2.3 3.38 6.52 8.12 6.52 13.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52a4 4 0 0 0 8 0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44,
    width: 16,
    height: 8,
    rx: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulpSvgrepoCom);
export default __webpack_public_path__ + "static/media/bulp-svgrepo-com.d02dc6df9d8cdf836acb4fb76c513e78.svg";
export { ForwardRef as ReactComponent };